import React from 'react';
import FullCalendar from '@fullcalendar/react';

type HavingFullCalendarRef = {
  getFullCalendarRef?: () => React.RefObject<FullCalendar>;
};

/**
 * Trigger a refetch of FullCalendar events via the global ref.
 *
 * The legacy calendar page exposes `window.getFullCalendarRef` — this
 * helper keeps call-sites from needing to know about that global.
 */
export function refreshFullCalendar() {
  const windowHavingRef = window as HavingFullCalendarRef;
  const fc =
    windowHavingRef.getFullCalendarRef && windowHavingRef.getFullCalendarRef();
  if (fc) {
    fc.current?.getApi()?.refetchEvents();
  }
}
